/**
 * Stub de emissor para product analytics (Segment / Mixpanel / Amplitude
 * — fornecedor sera decidido em ADR de observabilidade em F2+).
 *
 * Esta implementacao:
 *  - NAO conecta com provedor real
 *  - NAO aceita API key (zero secret em F1)
 *  - Apenas serializa o evento via o `sink` injetado (default: noop)
 *
 * O ponto e ter a forma do adapter pronta para o Backend plugar nos
 * call sites certos. Troca por adapter real e uma substituicao local
 * no composition root — todo o codigo de negocio continua importando
 * apenas `KpiEmitter`.
 */
import { validateKpiEvent } from './emitter.js';
export class StubAnalyticsKpiEmitter {
    sink;
    providerLabel;
    constructor(opts = {}) {
        this.sink =
            opts.sink ??
                (() => {
                    /* noop */
                });
        this.providerLabel = opts.providerLabel ?? 'unspecified';
    }
    async emit(event) {
        validateKpiEvent(event);
        try {
            this.sink(JSON.stringify(event));
        }
        catch {
            // Regra dura: emissao nunca pode derrubar o caller. Falha no
            // sink e engolida — o adapter real tera retry/backoff proprios.
        }
    }
}
//# sourceMappingURL=stub-analytics-emitter.js.map